import { BrowserRouter, Routes, Route } from 'react-router-dom';


// Global styles — import once here, applies everywhere
import './styles/global.css';

// Layout
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';


// Pages
import HomePage    from './pages/HomePage';
import GalleryPage from './pages/GalleryPage';
import AboutPage   from './pages/AboutPage';
import ContactPage from './pages/ContactPage';

// Gallery data
import {
  PORTRAIT_PHOTOS,  PORTRAIT_FILTERS,
  EVENTS_PHOTOS,    EVENTS_FILTERS,
  NATURE_PHOTOS,    NATURE_FILTERS,
  PRINTS_PHOTOS,    PRINTS_FILTERS,
} from './data/photos';

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />  {/* ← add this line */}
      <Navbar />

      <Routes>

        <Route path='/' element={<HomePage />} />

        <Route
          path='/portraits'
          element={
            <GalleryPage
              title='Portraits'
              description='People and pets — candid, warm, and on location.'
              filters={PORTRAIT_FILTERS}
              photos={PORTRAIT_PHOTOS}
            />
          }
        />

        <Route
          path='/events'
          element={
            <GalleryPage
              title='Events'
              description='Gatherings, milestones, and the moments in between.'
              filters={EVENTS_FILTERS}
              photos={EVENTS_PHOTOS}
            />
          }
        />

        <Route
          path='/nature'
          element={
            <GalleryPage
              title='Nature'
              description='The outdoors in all its forms — sweeping, still, and occasionally staring back at you.'
              filters={NATURE_FILTERS}
              photos={NATURE_PHOTOS}
            />
          }
        />

        <Route
          path='/prints'
          element={
            <GalleryPage
              title='Prints'
              description='Art prints available from the archive.'
              filters={PRINTS_FILTERS}
              photos={PRINTS_PHOTOS}
            />
          }
        />

        <Route path='/about'   element={<AboutPage />}   />
        <Route path='/contact' element={<ContactPage />} />

        {/* 404 fallback — swap for a proper NotFoundPage if you want */}
        <Route path='*' element={
          <div style={{ padding: '20vh 2rem', textAlign: 'center' }}>
            <p className='label'>404</p>
            <h1 className='heading-xl' style={{ marginTop: '0.5rem' }}>Page not found</h1>
          </div>
        } />

      </Routes>

      <Footer />
    </BrowserRouter>
  );
}
